const PhoneIcon = () => {
    return (
        <svg className={"svg-icon"} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.5 6.75C13.1213 6.75 13.625 6.24632 13.625 5.625C13.625 5.00368 13.1213 4.5 12.5 4.5C11.8787 4.5 11.375 5.00368 11.375 5.625C11.375 6.24632 11.8787 6.75 12.5 6.75Z"
                fill="white"/>
            <path
                d="M18.5 20.25V3.75C18.5 2.92157 17.8284 2.25 17 2.25L8 2.25C7.17157 2.25 6.5 2.92157 6.5 3.75L6.5 20.25C6.5 21.0784 7.17157 21.75 8 21.75H17C17.8284 21.75 18.5 21.0784 18.5 20.25Z"
                stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default PhoneIcon